import { useState } from "react";
import {
  Accordion,
  AccordionLink,
  AccordionLinks,
  MobileDrawerSection,
  MobileDrawerTitle,
} from "../styled/Header.styled";
import {
  EarnObject,
  ElectricObject,
  HeaderTitleArray,
  ReferralsObject,
  ResourcesObject,
  SupportObject,
  getHeaderLink,
} from "./data";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const MobileDrawer = ({ isOpen, handleChangeShow }) => {
  const [activeNum, setActiveNum] = useState();
  const handleActive = (val) => {
    if (val === activeNum) {
      return setActiveNum(null);
    }
    if (!activeNum && activeNum !== 0) {
      return setActiveNum(val);
    }
  };

  const getContent = (val) => {
    let o = undefined;
    switch (val) {
      case 0:
        o = ElectricObject;
        break;
      case 1:
        o = EarnObject;
        break;
      case 2:
        o = ReferralsObject;
        break;
      case 3:
        o = ResourcesObject;
        break;
      case 4:
        o = SupportObject;
        break;
    }
    return o;
  };

  return (
    <>
      <MobileDrawerSection className={isOpen ? "open" : "close"}>
        <CloseIcon
          color="primary"
          style={{ position:'fixed', right:'20px'}}
          onClick={handleChangeShow}
        />
        {HeaderTitleArray.map((item, idx) => (
          <>
            <MobileDrawerTitle onClick={() => handleActive(idx)}>
              <p>{item.title}</p>
              {activeNum === idx ? (
                <KeyboardArrowUpIcon color="primary" />
              ) : (
                <KeyboardArrowDownIcon color="primary" />
              )}
            </MobileDrawerTitle>
            <Accordion
              className={
                activeNum === idx ? "accordion-open" : "accordion-close"
              }
            >
              {idx !== 5 &&
                Object.entries(getContent(idx)).map(
                  ([category, items]) => (
                    <AccordionLinks>
                      <a href={getHeaderLink(category)} className="link-title">
                        {category}
                      </a>
                      {items.map((item, index) => (
                        <AccordionLink key={index}>
                          <a href={item.link}>{item.title}</a>
                        </AccordionLink>
                      ))}
                    </AccordionLinks>
                  )
                )}
            </Accordion>
          </>
        ))}
      </MobileDrawerSection>
    </>
  );
};

export default MobileDrawer;
